<div [formGroup]="form">
  <app-divider margin="24px 0 32px"/>

  <h1 class="h1-heading">Shareholder Details</h1>

  <div class="form-group">
    <app-shareholder-with-nbo-sign
      [formGroup]="selectControlFormGroupPart"
      [securityRegistryRecords]="securityRegistryRecords"
      (select)="onSelectCurrentShareholder($event)"
    />
  </div>

  <app-divider margin="24px 0"/>

  <div class="form-group share-types">
    <app-share-security-holdings-dropdown
      formControlName="securityHoldingId"
      [options]="securityRegistryRecordsHoldings"
    />
  </div>

  <div class="share-numbers-grid">
    <div class="form-group number-of-shares-cancelled">
      <app-input-number
        label="Number of Shares Cancelled"
        formControlName="numberOfSharesCancelled"
        [customErrors]="totalNumberOfSharesCustomErrors"
        [min]="0"
        [max]="this.selectedShareholderShareType?.number ?? 0"
      />
    </div>

    <div class="form-group consideration-paid">
      <app-input-number
        label="Consideration Paid"
        formControlName="considerationPaid"
        [customErrors]="totalNumberOfSharesCustomErrors"
        [min]="0"
        [max]="this.selectedShareholderShareType?.number ?? 0"
      />
    </div>

    <div class="form-group total-paid">
      <app-input-number
        label="Total Amount Paid"
        formControlName="totalPaid"
        [customErrors]="totalNumberOfSharesCustomErrors"
        [min]="0"
        [max]="this.selectedShareholderShareType?.paid ?? 0"
      />
    </div>

    <div class="form-group total-unpaid">
      <app-input-number
        label="Total Amount Unpaid"
        formControlName="totalUnpaid"
        [customErrors]="totalNumberOfSharesCustomErrors"
        [min]="0"
        [max]="this.selectedShareholderShareType?.unpaid ?? 0"
      />
    </div>
  </div>

  <div class="form-group" [hidden]="formShareNumberErrorMessageHidden">
    <app-validation-error
      [control]="form"
      [customErrors]="customErrorsOfShareCancellationNumbers"
    />
  </div>
</div>
